import type {
	OperationalEventPayload,
	ScreenEventPayload,
	TrackEventPayload,
	UIEventPayload,
} from '../events/analytics-web-client-types';
import { createBreadcrumbAPI, createBreadcrumbedEventChannel } from '../events/breadcrumbs';
import { createCatchingEventChannel } from '../events/core';
import type { CaptureExceptionPayload } from '../events/sentry-browser/bridge';

export type {
	CaptureExceptionPayload,
	OperationalEventPayload,
	ScreenEventPayload,
	TrackEventPayload,
	UIEventPayload,
};

export type BreadcrumbAttributes = {
	// TODO: Standardize the attributes we send
	/**
	 * Just arbitrary set of metadata you can add to your breadcrumbs. ATM they get added directly to GasV3 attributes.
	 */
	attributes?: Record<any, any>;
	/**
	 * If set, this breadcrumb won't be used in any of the data/PM related analytics services.
	 */
	isForDevsOnly?: boolean;
};

const breadcrumbAPI = createBreadcrumbAPI<BreadcrumbAttributes>();
export const { breadcrumbMountedEventChannel, Breadcrumb, useGetBreadcrumbs } = breadcrumbAPI;

export const externalGasV3UIEventChannel = createCatchingEventChannel<UIEventPayload>();
export const externalGasV3ScreenEventChannel = createCatchingEventChannel<ScreenEventPayload>();
export const externalGasV3TrackEventChannel = createCatchingEventChannel<TrackEventPayload>();
export const externalGasV3OperationalEventChannel =
	createCatchingEventChannel<OperationalEventPayload>();

export const externalSentryExceptionChannel = createCatchingEventChannel<CaptureExceptionPayload>();

export const internalGasV3UIEventChannel = createBreadcrumbedEventChannel<
	Omit<UIEventPayload, 'source'>,
	BreadcrumbAttributes
>(breadcrumbAPI, createCatchingEventChannel);
export const internalGasV3ScreenEventChannel = createCatchingEventChannel<ScreenEventPayload>();
export const internalGasV3TrackEventChannel = createBreadcrumbedEventChannel<
	Omit<TrackEventPayload, 'source'>,
	BreadcrumbAttributes
>(breadcrumbAPI, createCatchingEventChannel);
export const internalGasV3OperationalEventChannel = createBreadcrumbedEventChannel<
	Omit<OperationalEventPayload, 'source'>,
	BreadcrumbAttributes
>(breadcrumbAPI, createCatchingEventChannel);

export const internalSentryExceptionChannel = createBreadcrumbedEventChannel<
	CaptureExceptionPayload,
	BreadcrumbAttributes
>(breadcrumbAPI, createCatchingEventChannel);
